import script from "./ExamView.vue?vue&type=script&setup=true&lang=js"
export * from "./ExamView.vue?vue&type=script&setup=true&lang=js"

import "./ExamView.vue?vue&type=style&index=0&id=63283204&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63283204"]])

export default __exports__